import { useState } from "react";

import { Box } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

import { Button, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const Delete = ({ id, onDelete, buttonPosition }) => {
  const { getLabel } = useLocalization();

  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleConfirmDelete = () => {
    setConfirmDelete(false);
    onDelete(id);
  };

  const getButtonPosition = () => {
    if (buttonPosition === "left" || !buttonPosition) {
      return {
        right: "30px",
        top: "-5px",
      };
    } else {
      return {
        left: "30px",
        top: "-5px",
      };
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      gap={1}
      position="relative"
    >
      {confirmDelete ? (
        <Box
          display="flex"
          gap={1}
          position="absolute"
          zIndex={500}
          sx={{
            ...getButtonPosition(),
          }}
        >
          <Button
            onClick={handleConfirmDelete}
            size="small"
            variant="contained"
          >
            {getLabel("confirmDelete")}
          </Button>
          <Button
            onClick={() => setConfirmDelete(false)}
            size="small"
            variant="contained"
          >
            {getLabel("cancel")}
          </Button>
        </Box>
      ) : null}
      <IconButton
        size="small"
        onClick={() => setConfirmDelete(true)}
      >
        <DeleteIcon fontSize="24px" />
      </IconButton>
    </Box>
  );
};

export default Delete;
